import React, { useEffect } from 'react';
import * as d3 from "d3";
import havana from '../../../../../data/havana';

function Chromosome (props){
    
    const dataset = props.dataset,
        biobanks = props.biobanks,
        types = props.types,
        dna = props.dna,
        pos = props.pos,
        topView = props.topView,
        settings = props.settings,
        ranges = props.ranges,
        resolution = props.resolution,
        size = props.size,
        defineMinPval = props.defineMinPval,
        drawLines = props.drawLines,
        setSlot = props.setSlot,
        setLocus = props.setLocus;

    const chromosome = topView[2]

    function getFormat (resolution) {
        const n_chr = dna[chromosome],
            capacity = Math.ceil(n_chr.size/resolution),
            number = Math.ceil(n_chr.size/capacity),
            width = (size.width - size.margin.left) / number;
        const format = {
            size: capacity,
            number: number,
            width: width
        };
        return format
    };

    // function drawPosition (position) {
    //     const Xslot = format.width * (position+0.5) + size.margin.left
        
    //     d3.select('#clickLine01').attr('x1', Xslot).attr('x2', Xslot)
    //     d3.select('#linkLine01').attr('d', ()=>{
    //         const start = 'M' + Xslot + ',' + (size.margin.top+props?.biobanks.length*size.height+4)
    //         const curve1 = ' C' + Xslot + ',' + (size.margin.top+props?.biobanks.length*size.height+40) + ' '
    //         const curve2 = ((size.width+size.margin.left)/2) + ',' + (size.margin.top+size.margin.bottom+props?.biobanks.length*size.height-50) + ' '
    //         const end = ((size.width+size.margin.left)/2) + ',' + (size.margin.top+size.margin.bottom+props?.biobanks.length*size.height)
    //         return start+curve1+curve2+end
    //     })
    // };

    function cancelLayout () {
        d3.select('#thumbnail01').selectAll('.chromosome')
        .classed('chrHovered', false)
        .style('transform', undefined)
        .on('mouseenter', () => {})
        .on('mouseleave', () => {})
        .on('click', () => {});

        d3.selectAll('.lineHovered').classed('lineHovered', false)
    }


    function generateSlot (data, chromosome, format) {

        const newSlot = {
            chr: chromosome,
            low: data.low,
            high: data.high,
        }

        function operate() {
            setSlot(newSlot)
            setLocus({});
        }

        d3.selectAll('#position02, #view03').transition().duration(500).style('opacity', 0);
        d3.select('#slotCircle01').transition().duration(500).style('opacity', 1).attr('cx', format.width * (data.slot+0.5) + size.margin.left)
        setTimeout(operate, 500)
    }

    function getSlots (data, biobank, bbN, format) {
        
        const chrUI = data.map(d => {
            d[pos] = parseInt(d[pos]);
            d[biobank] = parseFloat(d[biobank]);
            return d;
        })

        let slots = [];
        
        for (let i = 0; i < format.number; i++) {
            slots.push({
                bb: bbN,
                chr: chromosome, 
                slot: i,
                low: format.size*[i],
                high: format.size*[i+1],
                elements: [],
        })}

        if (chrUI.length !== 0) {
            let current = 0;

            function recursiveCheck(e){
                if (e[pos] >= slots[current].high) {
                    current++;
                    recursiveCheck(e);
                }
            };
            
            chrUI.forEach(e => {
                recursiveCheck(e)
                slots[current].elements.push(e)
            })
        }

        slots = slots.map(item => {return {...item, value: defineMinPval(item.elements, biobank)}})
        return slots
    }

    function drawThumbnail (data, format) {

        biobanks.forEach((biobank,bbN) => {

            const logRanges = ranges[bbN],
                intRanges = logRanges.map(item => {return 10**item});

            const scalePvalueToShade = d3.scaleThreshold().domain(intRanges).range(settings.colors.pvalue),
                scaleNominalToShade = d3.scaleThreshold().domain(intRanges).range(settings.colors.nominal);

            function colorRects (datum, type) {
                if (type === 'pvalue') {
                    if (datum === undefined) return settings.blue0
                    else return scalePvalueToShade(datum)
                } else if (type === 'nominal') {
                    if (datum === undefined) return settings.gray1
                    else return scaleNominalToShade(datum)
                }
            }

            const slots = getSlots(data, biobank, bbN, format)
            
            d3.select(`#layer01_${bbN}`)
                .selectAll(".unit")
                .data(slots)
                .join("rect")
                    .classed("unit", true)
                    .attr('y', 0.5)
                    .attr('width', format.width)
                    .attr('height', size.height-1)
                    .on('mouseover', function(e, d) {
                        const Xslot = format.width * (d.slot+0.5) + size.margin.left
                        d3.select('#hoverLine01')
                            .style('display', 'block')
                            .attr('x1', Xslot).attr('x2', Xslot);
                    })
                    .on('click', (e,d) => generateSlot(d, chromosome+1, format))
                    .transition().duration(500)
                        .attr('x', d => format.width * d.slot + size.margin.left)
                        .attr('fill', d => colorRects(d.value, types[bbN]))

        })
    }

    useEffect(()=>{

        if (topView[1] === 'chr') {
            const format = getFormat(resolution);

            cancelLayout();
            drawLines([[size.margin.left, size.width]]);
            drawThumbnail(dataset, format);
        }

    })

    return (
        <></>
        )
}
export default Chromosome;